const ifParamChanges = (func: Function) => {
  let lastArg: any;
  return (arg: any) => {
    if (lastArg !== arg) {
      lastArg = arg;
      func(lastArg);
    }
  };
};

const addListener = ifParamChanges((leafletMap: any) => {
  leafletMap.on('dragstart', () => {
    const removePoint: HTMLElement | null = document.querySelector('a[title="Delete last point drawn"]');
    if (removePoint !== null) {
      removePoint.click();
    }
  });
});

export const improveDragging = (mapRef: any) => {
  if (mapRef && mapRef.leafletElement) {
    addListener(mapRef.leafletElement);
  }
};



// WEBPACK FOOTER //
// ./src/labeling-screen/dragging-fix.ts